import React from 'react';
import TextField from '@mui/material/TextField';
import { AlFormField } from './AlFormField/AlFormField';

const AlTextField = (props) => {
    return <AlFormField autoComplete="off" {...props} variant="outlined" field={TextField} />;
};

export { AlTextField };
